import { Injectable } from '@angular/core';
import {BehaviorSubject} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class BusyService {
  busyRequestCount = 0;
    private readonly loadingSubject = new BehaviorSubject<boolean>(false);
    readonly loading$ = this.loadingSubject.asObservable();

  busy(){
    this.busyRequestCount++;
      if (this.busyRequestCount === 1) {
          this.loadingSubject.next(true);
      }
  }

  idle(){
    if (this.busyRequestCount <= 0) {
      this.busyRequestCount = 0;
      return;
    }
    this.busyRequestCount--;
    if (this.busyRequestCount <= 0) {
      this.busyRequestCount = 0;
        this.loadingSubject.next(false);
    }
  }

    /** Clears a stuck global loader (e.g. after session expiry or navigation races). */
  forceIdle() {
    this.busyRequestCount = 0;
        this.loadingSubject.next(false);
    this.resetDocumentInteractionState();
  }

  private resetDocumentInteractionState() {
    if (typeof document === 'undefined') {
      return;
    }
    document.body.style.removeProperty('overflow');
    document.body.style.removeProperty('pointer-events');
    document.documentElement.style.removeProperty('overflow');
    document.documentElement.style.removeProperty('pointer-events');
    document.querySelectorAll('.ngx-spinner-overlay').forEach((node) => node.remove());
  }
}
